<template>
  <div class="card-bg-details shadow">
    <div class="card-body-track pb-1">
      <div v-if="trackFiles" v-bind="existingTrackStems">
        <div v-for="stem in trackStems">
          <p class="">File: <span class="text-bold">{{ stem.stemname }}</span></p>

          <div class="upload-item-box my-2">
            <uploadItem class="my-2" :key="stem.id" :name="stem.stemname" :url="stem.stemurl" />
          </div>
        </div>
      </div>
      <div v-else></div>

      <div class="w-100 d-flex justify-content-between align-items-center">
        <div>
          <p v-if="trackStatus === 'Complete'" v-for="stem in trackStems" v-bind="finishedTrackUrl" class="">
            Master: <span class="text-bold">
              {{ stem.stemname }}
            </span>
          </p>
        </div>

        <div v-if="approveStatus == 1 && finalStem[0]" class="d-stem-box">
          <a :href="finalStem[0]" class="d-stem-btn">Download Stem</a>
        </div>
        <div v-else></div>
      </div>

      <div>
        <div class="upload-item-box my-2" v-bind="finalStemUrl" v-if="trackStatus === 'Complete'">
          <finalItem class="my-2" v-for="final in finalMix" :key="final" mix="final" name="Final Mix" :id="id"
            :url="final" :approved="approveStatus" />
        </div>
        <div class="upload-item-box my-2" v-else>No Final Tracks</div>
      </div>
    </div>
  </div>
</template>

<script>
import uploadItem from "@/components/UploadsItem.vue";

import finalItem from "@/components/FinalMixItem.vue";
export default {
  components: { uploadItem, finalItem },
  data() {
    return {
      elements: this.$store.state.trackData.elementList,
      refStems: [],
      trackStems: [],
      finalMix: [],
      finalStem: [],
      trackName: this.$store.state.trackData.trackName,
      refiles: [],
      id: this.$route.params.id,
    };
  },
  created() {
    this.existingRefStems;
    this.existingTrackStems;
  },
  computed: {
    existingRefStems() {
      this.$store
        .dispatch("trackData/setRefStemElements", this.$route.params.id)
        .then(() => {
          console.log(this.$store.state.trackData.existingRefStems);
          this.refStems = this.$store.state.trackData.existingRefStems;
        });
      return 0;
    },
    existingTrackStems() {
      this.$store
        .dispatch("trackData/setexistingStems", this.$route.params.id)
        .then(() => {
          console.log(this.$store.state.trackData.existingStems);
          this.trackStems = this.$store.state.trackData.existingStems;
        });
      return 0;
    },
    approveStatus() {
      return this.$store.state.trackData.approved;
    },
    showRemixButton() {
      return (
        this.$store.state.trackData.remixData.length > 0 &&
        this.$store.state.trackData.trackStatus == "Complete"
      );
    },
    finishedTrackUrl() {
      this.$store
        .dispatch(
          "trackData/fetchFinshedTracksByTrackId",
          this.$route.params.id
        )
        .then(() => {
          this.finalMix.push(this.$store.state.trackData.currentFinishedTrack);
        });
    },
    finalStemUrl() {
      this.$store
        .dispatch("trackData/fetchFinalStemByTrackId", this.$route.params.id)
        .then(() => {
          this.finalStem.push(this.$store.state.trackData.currentFinalStem);
        });
    },
    disabledClass() {
      return this.$store.state.apiEvents.remainingRevisions > 0 ||
        this.$store.state.apiEvents.remainingRevisions == -1
        ? " active-button"
        : " active-button-disabled";
    },
    disabledButton() {
      return this.$store.state.apiEvents.remainingRevisions > 0 ||
        this.$store.state.apiEvents.remainingRevisions == -1
        ? 0
        : 1;
    },
    trackStatus() {
      return this.$store.state.trackData.trackStatus;
    },
    trackFiles() {
      return this.trackStems.length > 0 ? 1 : 0;
    },
    refFiles() {
      return this.refStems.length > 0 ? 1 : 0;
    },
  },
  methods: {
    submitRemix() {
      this.$store.dispatch("apiEvents/useRevisionCredit").then(() => {
        this.$store.dispatch("trackData/sendRemixData").then(() => { });
      });
    },
  },
  mounted() {
    this.$store.dispatch(
      "trackData/fetchRemixesByTrackId",
      this.$store.state.trackData.currentTrackId
    );
  },
};
</script>

<style scoped>
.text-bold {
  font-weight: bold;
}

.d-stem-btn,
.d-stem-btn:hover {
  color: #2bfed1;
  font-size: 14px;
  text-decoration: none;
}

.d-stem-box {
  padding: 5px 10px 5px 10px;
  border-radius: 20px;
  border: 1px solid #2bfed1;
  transition: 0.1s ease-in-out;
}

.d-stem-box:hover {
  background-color: #2bfed024;
  border: 1px solid #2bfed024;
}

.upload-item-box {
  overflow-y: scroll;
  overflow-x: hidden;
}
</style>
